var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.2")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.39 0 0 0.39 200 200)",
    id: "WhatsApp-Logo-Icon"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID__Linear1_1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -512 -512 0 256 512)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(37,207,67)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(97,253,125)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "url(#SVGID__Linear1_1)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256, -256)",
    d: "M 116.225 -0.001 c -11.264 0.512 -26.112 1.536 -32.768 3.072 c -10.24 2.048 -19.968 5.12 -27.648 9.216 c -9.728 4.608 -17.92 10.752 -25.088 17.92 c -7.68 7.68 -13.824 15.872 -18.432 25.6 c -4.096 7.68 -7.168 17.408 -9.216 27.648 c -1.536 6.656 -2.56 21.504 -2.56 32.768 c -0.512 4.608 -0.512 10.752 -0.512 13.824 l 0 251.905 l 0 13.824 c 0.512 11.264 1.536 26.112 3.072 32.768 c 2.048 10.24 5.12 19.968 9.216 27.648 c 4.608 9.728 10.752 17.92 17.92 25.088 c 7.68 7.68 15.872 13.824 25.6 18.432 c 7.68 4.096 17.408 7.168 27.648 9.216 c 6.656 1.536 21.504 2.56 32.768 2.56 c 4.608 0.512 10.752 0.512 13.824 0.512 l 251.904 0 l 13.824 0 c 11.264 -0.512 26.112 -1.536 32.768 -3.072 c 10.24 -2.048 19.968 -5.12 27.648 -9.216 c 9.728 -4.608 17.92 -10.752 25.088 -17.92 c 7.68 -7.68 13.824 -15.872 18.432 -25.6 c 4.096 -7.68 7.168 -17.408 9.216 -27.648 c 1.536 -6.656 2.56 -21.504 2.56 -32.768 c 0.512 -4.608 0.512 -10.752 0.512 -13.824 l 0 -265.729 c -0.512 -11.264 -1.536 -26.112 -3.072 -32.768 c -2.048 -10.24 -5.12 -19.968 -9.216 -27.648 c -4.608 -9.728 -10.752 -17.92 -17.92 -25.088 c -7.68 -7.68 -15.872 -13.824 -25.6 -18.432 c -7.68 -4.096 -17.408 -7.168 -27.648 -9.216 c -6.656 -1.536 -21.504 -2.56 -32.768 -2.56 c -4.608 -0.512 -10.752 -0.512 -13.824 -0.512 l -265.728 0 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.39 0 0 0.39 201.87 198.89)",
    id: "WhatsApp-Logo-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-260.78, -253.15)",
    d: "M 344.754 289.698 c -4.56 -2.282 -26.98 -13.311 -31.161 -14.832 c -4.18 -1.521 -7.219 -2.282 -10.259 2.282 c -3.041 4.564 -11.78 14.832 -14.44 17.875 c -2.66 3.042 -5.32 3.423 -9.88 1.14 c -4.561 -2.281 -19.254 -7.095 -36.672 -22.627 c -13.556 -12.087 -22.709 -27.017 -25.369 -31.581 c -2.66 -4.564 -0.283 -7.031 2 -9.304 c 2.051 -2.041 4.56 -5.324 6.84 -7.986 c 2.28 -2.662 3.04 -4.564 4.56 -7.606 c 1.52 -3.042 0.76 -5.705 -0.38 -7.987 c -1.14 -2.282 -10.26 -24.72 -14.06 -33.848 c -3.701 -8.889 -7.461 -7.686 -10.26 -7.826 c -2.657 -0.132 -5.7 -0.16 -8.74 -0.16 c -3.041 0 -7.98 1.141 -12.161 5.704 c -4.18 4.564 -15.96 15.594 -15.96 38.032 c 0 22.438 16.34 44.116 18.62 47.159 c 2.281 3.043 32.157 49.089 77.902 68.836 c 10.88 4.697 19.374 7.501 25.997 9.603 c 10.924 3.469 20.866 2.98 28.723 1.806 c 8.761 -1.309 26.98 -11.029 30.781 -21.677 c 3.799 -10.649 3.799 -19.777 2.659 -21.678 c -1.139 -1.902 -4.179 -3.043 -8.74 -5.325 m -83.207 113.573 l -0.061 0 c -27.22 -0.011 -53.917 -7.32 -77.207 -21.137 l -5.539 -3.287 l -57.413 15.056 l 15.325 -55.959 l -3.608 -5.736 c -15.184 -24.145 -23.203 -52.051 -23.192 -80.704 c 0.033 -83.611 68.083 -151.635 151.756 -151.635 c 40.517 0.016 78.603 15.811 107.243 44.474 c 28.64 28.663 44.404 66.764 44.389 107.283 c -0.035 83.617 -68.083 151.645 -151.693 151.645 m 129.102 -280.709 c -34.457 -34.486 -80.281 -53.487 -129.103 -53.507 c -100.595 0 -182.468 81.841 -182.508 182.437 c -0.013 32.156 8.39 63.546 24.361 91.212 l -25.892 94.545 l 96.75 -25.37 c 26.657 14.535 56.67 22.194 87.216 22.207 l 0.075 0 c 100.586 0 182.465 -81.852 182.506 -182.448 c 0.019 -48.751 -18.946 -94.59 -53.405 -129.076",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8e58e3e12498e5b07e4328e4cdaff7e0.svg";
export { ForwardRef as ReactComponent };